import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=07706289"
import script from "./documentsBlock.ts?vue&type=script&lang=js&external"
export * from "./documentsBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports